import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Select } from "./Select";
import { api } from "./api";
import IN from "./images/in.svg";
import "./scss/_leadsModal.scss";

export const LeadsForm = (props) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [cityOptions, setCityOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  const handleChange = (e, field) => {
    const newValues = { ...values };

    newValues[e.target?.name || field.name] =
      e.target && e.target.value
        ? e.target.value
        : field && field.name
        ? e
        : "";

    setValues(newValues);
  };

  const handleError = (e, a) => {
    const newErrors = { ...errors };

    if (e.target.name === "mobile") {
      let mobileFormat = new RegExp(/^[6-9]$/);

      newErrors[e.target.name] =
        e.target.value.length !== 10 ||
        !mobileFormat.test(e.target.value.charAt(0));
    } else {
      newErrors[e.target.name] = e.target.value.trim().length < 3;
    }

    setErrors(newErrors);
  };
  const errorKeys = Object.keys(errors);

  const errorsArr = errorKeys.filter((key) => errors[key]);

  let disableButton = false;
  if (errorsArr.length) {
    disableButton = true;
  }
  if (Object.keys(values).length !== 5) {
    disableButton = true;
  } else {
    disableButton = false;
  }

  const submitpayload = useCallback(async () => {
    try {
      if (!errorsArr.length) {
        values.city = values.city.value;
        values.state = values.state.value;
        await api.post(
          "su/affiliate/leads",
          { leads: [values] },
          {
            headers: {
              "x-access-token":
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjE0OCwibmFtZSI6Ijk1NTU5NDQ0MzkuYWZmaWxpYXRlIiwiZW1haWwiOiJwdXNoa2FyLnJhai50aGFrdXJAZ21haWwuY29tIiwibW9iaWxlIjoiOTU1NTk0NDQzOSIsInVzZXJfZ3JvdXAiOiJhZmZpbGlhdGUiLCJ1c2VyX25hbWUiOiI5NTU1OTQ0NDM5LmFmZmlsaWF0ZSIsInRsIjpudWxsLCJVc2VyX1RlYW0iOm51bGwsImlzX2FjdGl2ZSI6MSwiaWF0IjoxNjI5NzAxOTY5LCJleHAiOjE2OTI3NzM5Njl9.2BMIUbXUQ4JcmD-f1yVaDeMCLPvhETeL-YBK2UjpIPg",
            },
          }
        );
        window.cuteToast({
          type: "success",
          message: "Lead Has Been Saved",
          timer: 2000,
        });

        setInterval(() => window.location.reload(), 2100);
      }
    } catch {}
  }, [values, errorsArr]);

  const StateDropdownStyle = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? 0 : 0,
      // This line disable the blue border
      boxShadow: state.isFocused ? 0 : 0,
      "&:hover": {
        border: state.isFocused ? 0 : 0,
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(0, 0, 0, 0.6)",
    }),
  };
  const stateApiCall = useCallback(async () => {
    const { data } = await api.get(`su/affiliate/state`);
    const stateOptions = data.data.states.map((stateResponse, index) => {
      return { value: stateResponse, label: stateResponse };
    });
    setStateOptions(stateOptions);
  }, []);

  const cityApiCall = useCallback(async () => {
    const { data } = await api.get(`su/affiliate/state?city=1`);
    const cityOptions = data.data.city.map((city, index) => {
      return { value: city.city, label: city.city };
    });
    setCityOptions(cityOptions);
  }, []);

  useEffect(() => {
    stateApiCall();
    cityApiCall();
  }, [stateApiCall, cityApiCall]);

  // const numberError = (e) => {
  //   let mobileFormat = new RegExp(/^[6-9]$/);
  //   if (e.target.value.length < 10) {
  //     handleNumberError(true);
  //   } else if (e.target.value.length === 10) {
  //     handleNumberError(false);
  //   }
  //   if (mobileFormat.test(e.target.value.charAt(0))) {
  //     handleNumberError(false);
  //   } else {
  //     handleNumberError(true);
  //   }
  // };

  // const nameError = (e) => {
  //   if (e.target.value.trim().length < 3) {
  //     handleNameError(true);
  //   } else {
  //     handleNameError(false);
  //   }
  // };

  return (
    <Fragment>
      <div className="GivenLeads__Modal">
        <div className="LeadsModal__modalBody">
          <div className="LeadsModal__modalBody--instituteHead">
            <span>Coaching/School/Institute</span>
          </div>
          <div
            className="LeadsModal__modalBody--institute"
            style={{ marginBottom: "2.1rem" }}
          >
            <input
              id="institute"
              type="string"
              name="coachingName"
              value={values.coachingName}
              onChange={handleChange}
              placeholder="eg. DAV Public School "
              onBlur={handleError}
              autoComplete="off"
            />
          </div>
          {errors.coachingName ? (
            <div className="LeadsModal__modalBody--instituteError">
              * Institute Name Not Valid
            </div>
          ) : (
            ""
          )}
          <div className="LeadsModal__modalBody--nameHead">Owner’s Name</div>
          <div
            className="LeadsModal__modalBody--name"
            style={{ marginBottom: "2.1rem" }}
          >
            <input
              id="name"
              type="string"
              name="ownerName"
              value={values.ownerName}
              onChange={handleChange}
              placeholder="eg. harsh srivastava"
              onBlur={handleError}
              autoComplete="off"
            />
          </div>
          {errors.ownerName === true ? (
            <div className="LeadsModal__modalBody--nameError">
              * Name Not Valid
            </div>
          ) : (
            ""
          )}
          <div className="LeadsModal__modalBody--MobileHead">
            Owner’s number
          </div>
          <div className="LeadsModal__modalBody--MobileNumber">
            <img className="LeadsModal__modalBody--IN" src={IN} alt="IN" />
            <input
              id="mobile"
              name="mobile"
              value={values.mobile}
              type="number"
              onChange={handleChange}
              pattern="[0-9]*"
              placeholder="eg. 9898989898"
              onBlur={handleError}
            />
          </div>
          {errors.mobile === true ? (
            <div className="LeadsModal__modalBody--PhoneError">
              * Phone Number Not Valid
            </div>
          ) : (
            ""
          )}

          <div className="LeadsModal__modalBody--cityHead">City</div>
          <div
            className="LeadsModal__modalBody--city"
            style={{ marginBottom: "2.1rem", padding: 0 }}
          >
            <Select
              value={values.city}
              className="cityDropdown"
              name="city"
              components={{ IndicatorSeparator: () => null }}
              styles={StateDropdownStyle}
              placeholder="Your City"
              options={cityOptions}
              // onBlur={() => {
              //   const newError = { ...errors };

              //   newError.city = values.city === "";

              //   setErrors(newError);
              // }}
              onChange={handleChange}
            />
          </div>

          <div className="LeadsModal__modalBody--stateHead">State</div>
          <div className="LeadsModal__modalBody--state" style={{ padding: 0 }}>
            <Select
              value={values.state}
              className="cityDropdown"
              name="state"
              components={{ IndicatorSeparator: () => null }}
              styles={StateDropdownStyle}
              placeholder="Your State"
              options={stateOptions}
              // onBlur={handleError}
              // onBlur={() => {
              //   const newError = { ...errors };

              //   newError.state = values.state === "";

              //   setErrors(newError);
              // }}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="LeadsModal__modalFooter">
        <button
          style={{
            background: disableButton ? "#E5E5E5" : "#009ae0",
          }}
          onClick={submitpayload}
          disabled={disableButton}
          className="LeadsModal__modalFooter--SaveBtn"
        >
          Done
        </button>
      </div>
    </Fragment>
  );
};
